import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MessageDialog from "components/__reusable/MessageDialog";
import PrimaryActionButton from "components/__reusable/PrimaryActionButton";
import useAppSelector from "hooks/useAppSelector";
import useAppDispatch from "hooks/useAppDispatch";
import { resetSuccessStatus } from "features/success/successSlice";
import Desktop from "assets/images/desktop.png";
import Mobile from "assets/images/mobile.png";
import SecondaryActionButton from "components/__reusable/SecondaryActionButton";

const SuccessMessageDialog = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    success,
    title,
    message,
    isPublished,
    isDeleted,
    isStudentCreated,
    onClose,
  } = useAppSelector((state) => state.success);

  const close = () => {
    onClose && onClose();
    dispatch(resetSuccessStatus());
  };

  const renderStudentCreatedActionButtons = () => {
    return (
      <div className="w-full flex items-center justify-center space-x-4 my-8">
        <SecondaryActionButton
          label={t("_student_form._return_to_student_list")}
          onClick={() => {
            close();
            const classId = window.location.pathname.split("/")[2];
            navigate(`/class/${classId}/student`);
          }}
        />
        <PrimaryActionButton
          label={t("_student_form._goto_registration")}
          onClick={() => {
            close();
            const classId = window.location.pathname.split("/")[2];
            window.location.href = `/class/${classId}/student/new`;
          }}
        />
      </div>
    );
  };

  const renderActionButtons = () => {
    return isDeleted ? (
      <button
        type="button"
        className="w-full bg-red-600 text-white text-center px-6 py-2 rounded font-semibold shadow hover:bg-red-700 transition"
        onClick={() => close()}
      >
        {t("_generic._close")}
      </button>
    ) : (
      <PrimaryActionButton
        label={t("_generic._close")}
        onClick={() => close()}
      />
    );
  };

  return success ? (
    <MessageDialog>
      <div className="flex flex-col justify-center items-center space-y-6 max-w-4xl mx-auto">
        <h2
          className={`text-2xl font-semibold text-center${
            isDeleted ? " text-red-600" : ""
          }`}
        >
          {t(title)}
        </h2>
        <pre className="text-center whitespace-pre-wrap">{t(message)}</pre>

        {isPublished && (
          <>
            <div className="w-full my-8">
              <table className="w-full">
                <tbody>
                  <tr>
                    <td className="text-center align-center px-2">
                      <div className="flex flex-col items-center justify-between">
                        <img
                          src={Desktop}
                          alt="Desktop admin panel"
                          className="w-64 md:w-80 h-auto"
                        />
                      </div>
                    </td>
                    <td className="text-center align-middle px-2 w-24">
                      <div className="flex items-center justify-center space-x-0.5">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="gray"
                          style={{ opacity: 0.3 }}
                        >
                          <polygon points="6,4 20,12 6,20" />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="gray"
                          style={{ opacity: 0.6 }}
                        >
                          <polygon points="6,4 20,12 6,20" />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="gray"
                          style={{ opacity: 1 }}
                        >
                          <polygon points="6,4 20,12 6,20" />
                        </svg>
                      </div>
                    </td>
                    <td className="text-center align-top px-2 h-full">
                      <div className="flex flex-col items-center justify-between h-full flex-grow">
                        <img
                          src={Mobile}
                          alt="Mobile app notification"
                          className="w-32 md:w-40 h-auto"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-center align-top px-2">
                      <div className="mt-2">
                        <span className="text-sm text-gray-600">管理画面</span>
                      </div>
                    </td>
                    <td></td>
                    <td className="text-center align-top px-2">
                      <div className="mt-2">
                        <span className="text-sm text-gray-600">
                          保護者アプリ
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
        {isStudentCreated
          ? renderStudentCreatedActionButtons()
          : renderActionButtons()}
      </div>
    </MessageDialog>
  ) : (
    <></>
  );
};

export default SuccessMessageDialog;
